import {
    SET_HAPPINESS_TIPS_CATEGORIES,
    SET_HAPPINESS_TIPS_CATEGORIES_DELETE
} from "./types/mutations.js";

const mutations = {
    [SET_HAPPINESS_TIPS_CATEGORIES]: (state, payload) => {
        state.categories = payload;
    },
    [SET_HAPPINESS_TIPS_CATEGORIES_DELETE]: (state, payload) => {
        state.categories = state.categories.filter(item => item.happinessCategoryTipsId !== payload);
    }
};

export default mutations;
